import { FadeUp, Overline } from "@/components/Reveal";

const SECTORS = [
  { name: "Data Centres", desc: "AI, HPC and infrastructure operators" },
  { name: "AI Cloud Operators", desc: "Compute and accelerated cloud providers" },
  { name: "System Integrators", desc: "Enterprise and infrastructure solution partners" },
  { name: "Enterprise IT", desc: "Corporate technology and infrastructure buyers" },
  { name: "Resellers", desc: "Professional technology resellers" },
  { name: "Distributors", desc: "Regional and international channel partners" },
  { name: "Research & HPC", desc: "Universities, laboratories and compute-intensive organisations" },
  { name: "Government & Institutional", desc: "Public-sector and institutional procurement" },
];

export const Sectors = () => (
  <section className="relative py-16 lg:py-20 bg-[#FAFAFA] border-y border-midnight/10" data-testid="sectors-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp>
        <Overline>Who We Serve</Overline>
        <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-midnight">
          Built for serious technology buyers.
        </h2>
      </FadeUp>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {SECTORS.map((s, i) => (
          <FadeUp key={s.name} delay={i * 0.04}>
            <div
              className="bg-white hairline px-6 py-5 group hover:border-gold/50 hover:shadow-medium transition-[border-color,box-shadow] duration-300"
              data-testid={`sector-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="flex items-baseline justify-between">
                <p className="font-heading font-medium text-midnight group-hover:text-gold transition-colors duration-300">
                  {s.name}
                </p>
                <span className="font-heading text-xs font-light text-gold/80">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="text-xs text-midnight/50 mt-1.5 leading-relaxed">{s.desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
